/**
 * Parse decimal fraction from 'numerator/denominator' fraction string
 * @param {String} fraction - 'numerator/denominator' string, e.g. '1/4', '4/1', '9/2',
 * @return {Number} decimal fraction, e.g. 0.25, 4.0, 4.5
 */
export default function parseFraction(frac) {
    const [numerator, denominator] = (frac === 'Evs')
        ? ['1', '1']
        : frac.split('/')
    return parseInt(numerator, 10) / parseInt(denominator, 10);
}



// WEBPACK FOOTER //
// /src/js/common/utils/parseFraction.js